import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {Issue} from "../domain/entities/issue.entity";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {UpdateIssueCommand} from "../commands/update-issue.command";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {TransformerHelper} from "../helpers/transformer.helper";

@injectable()
@transformer({
    source: UpdateIssueCommand,
    target: `dto`
})
export class UpdateIssueCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Issue> {

    protected async toDTO(issue: Issue): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(issue);
    }

}